<script setup lang="ts">
import { computed } from 'vue';
import { useConfirm } from '@/composables/useConfirm';
import ConfirmDialog from './ConfirmDialog.vue';

// Mount once at the app shell (after <ToastStack />). Watches the confirm
// queue and renders the head-of-queue request as a modal dialog.

const { queue, settle } = useConfirm();

const head = computed(() => queue.value[0] ?? null);

function onConfirm() {
    if (head.value) settle(head.value.id, true);
}

function onCancel() {
    if (head.value) settle(head.value.id, false);
}
</script>

<template>
    <ConfirmDialog
        v-if="head"
        :open="true"
        :opts="head.opts"
        @confirm="onConfirm"
        @cancel="onCancel"
    />
</template>
